import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { feedItems } from '@/mocks/home';

const EXTRA_FEED = [
  {
    id: 'f5',
    platform: '微博',
    tag: 'ri-weibo-fill',
    time: '3 天前',
    title: '关于近期内容节奏调整的一点说明',
    excerpt:
      '有读者反馈更新太密看不过来。这次调整了发布节奏，把同类内容合并成一条，读起来会更清爽一些。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20terracotta%20and%20sage%20abstract%20editorial%20background%20with%20soft%20layered%20paper%20shapes%2C%20minimal%20modern%20composition%2C%20gentle%20natural%20lighting%2C%20muted%20calm%20palette%2C%20artistic%20non%20realistic%20style%2C%20high%20detail&width=1200&height=800&seq=hlgl-feed-05&orientation=landscape',
    views: '7,410',
    comments: '41',
    likes: '389',
  },
];

export default function UpdateFeed() {
  const [expanded, setExpanded] = useState(false);
  const visibleItems = expanded ? [...feedItems, ...EXTRA_FEED] : feedItems;

  return (
    <section id="feed" className="scroll-mt-24 bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="02"
            eyebrow="LATEST UPDATES"
            title="各渠道最新动态"
            description="微博、公众号、推特与电报的内容汇总到同一条时间线上，按发布时间先后排列。"
          />
        </Reveal>

        <div className="mt-12 flex flex-col gap-10 md:mt-16 md:gap-14">
          {visibleItems.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="grid grid-cols-1 lg:grid-cols-12">
                  <div className="relative h-56 w-full overflow-hidden lg:col-span-7 lg:h-[380px]">
                    <img
                      src={item.cover}
                      alt={`${item.platform} 最新动态配图`}
                      title={`黑料官方 ${item.platform} 动态`}
                      className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                    <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-foreground-950/70 px-3 py-1.5 text-xs text-background-50 backdrop-blur-sm">
                      <i className={`${item.tag} text-sm`}></i>
                      {item.platform}
                    </span>
                  </div>

                  <div className="flex flex-col justify-between p-6 lg:col-span-5 lg:p-8">
                    <div>
                      <div className="flex items-center gap-3 text-xs text-foreground-500">
                        <span className="font-label tracking-widest">NO.{String(index + 1).padStart(2, '0')}</span>
                        <span className="h-px w-6 bg-background-300" aria-hidden="true"></span>
                        <span>{item.time}</span>
                      </div>
                      <h3 className="mt-5 font-heading text-xl font-semibold leading-snug text-foreground-950 md:text-2xl">
                        {item.title}
                      </h3>
                      <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                        {item.excerpt}
                      </p>
                    </div>

                    <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-background-200 pt-5 text-xs text-foreground-500">
                      <span className="flex items-center gap-1.5">
                        <i className="ri-eye-line text-base"></i>
                        {item.views}
                      </span>
                      <span className="flex items-center gap-1.5">
                        <i className="ri-chat-3-line text-base"></i>
                        {item.comments}
                      </span>
                      <span className="flex items-center gap-1.5 text-primary-600">
                        <i className="ri-heart-3-fill text-base"></i>
                        {item.likes}
                      </span>
                      <span className="ml-auto flex items-center gap-1.5 text-foreground-700">
                        阅读全文
                        <i className="ri-arrow-right-line text-base"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex justify-center md:mt-16">
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
          >
            <i className={expanded ? 'ri-arrow-up-line text-base' : 'ri-arrow-down-line text-base'}></i>
            {expanded ? '收起动态' : '查看更多动态'}
          </button>
        </div>
      </div>
    </section>
  );
}